import { z } from 'zod';

export const WikiSourceImpactItemSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  kind: z.string(),
});
export type WikiSourceImpactItem = z.infer<typeof WikiSourceImpactItemSchema>;

export const WikiSourceImpactSchema = z.object({
  count: z.number().int().nonnegative(),
  sources: z.array(WikiSourceImpactItemSchema),
});
export type WikiSourceImpact = z.infer<typeof WikiSourceImpactSchema>;
